/*
 * @Author: fengzhongmei
 * @Date: 2020-03-09 19:47:12
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-03-15 13:24:23
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
 */
const helpInfoMap = {
    计费配置: '<a>资源计费配置：</a>私有云支持自定义计费策略，可使用已定义的计算、存储、网络对该云环境进行费用配置；公有云不支持自定义计费策略，使用开启云平台计费后，会根据选择配置查询公有云的配置价格，可自定义折扣。<br/><a>组织计费配置：</a>组织折扣仅适用于产品计费配置中，开启了组织折扣开关的产品。',
    计费策略: '费策略需要在计费配置中关联资源才能生效，其中计费类别为计算、存储、网络可在资源计费配置中关联云环境生效； 服务类别用于产品计费配置中，在具体产品中配置后生效。',
    密钥对: '密钥对是一种新的远程登录主机的认证方式，是一种区别于传统的用户名加密码模式的认证方式。该平台将云环境密钥对的公钥信息同步到本地，您可以在“个人设置-SSH密钥”中将私钥导入平台，便于后续创建主机使用，亦可直接使用密钥SSH登录对应主机进行操作。',
    安全组: '安全组 是一种虚拟防火墙，用于设置单台或多台云服务器进行出/入流量控制。它是重要的网络安全隔离手段，每个云主机至少属于一个安全组。用户可以在该模块设定安全组策略，对绑定的云主机进行内、外网访问权限控制。',
    高性能计算HPC: '提供高性能计算共享资源池，专属资源池的申请购买及管理功能，支持通过Web控制台及WebSSH登录节点进行使用。',
    弹性文件服务: '弹性文件服务（Scalable File Service，SFS）提供按需扩展的高性能文件存储，可为HPC集群提供高性能并行文件系统数据访问。',
    ModelArts: 'ModelArts 是面向开发者的一站式 AI 平台，为机器学习与深度学习提供海量数据预处理及交互式智能标注、大规模分布式训练、自动化模型生成，及端-边-云模型按需部署能力，帮助用户快速创建和部署模型，管理全周期 AI 工作流。专属资源池为专业用户提供高性能，高效率的优化体验，资源池支持包周期计费，满足不同专业用户需求。',
    消息设置: '提供消息设置功能，可以根据实际需要配置接收消息的类型及对应消息人。'

}

export {
    helpInfoMap
}
